import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            按不同类型快速查找感兴趣的女优
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-100 transition-colors mb-3">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {category.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1">{category.count} 位</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}